import withTracker from '.././withTracker';
import Subscribe from '../../containers/user/Subscribe';

const userSubscribe = {
  path: '/users/subscribe',
  component: withTracker(Subscribe)
};

export default userSubscribe;
